import { getOnFetchingUserRequest } from './requests';

export const getFetchUserSaga = async ({ action }) => {
  return getOnFetchingUserRequest(action.payload);
};
